import { useEffect, useState } from "react";
import OrderService from "../service/OrderService";

const useBankTransfers = ({ onBankTransferError, onSuccess } = {}) => {
  const [loadingTransfers, setLoadingTransfers] = useState(true);
  const [transfers, setTransfers] = useState([]);

  const productService = new OrderService();

  const fetchTransfers = async () => {
    setLoadingTransfers(true);
    try {
      let resTransfers = await productService.getPendingTransfers();

      if (onBankTransferError && resTransfers.messageCode !== 200001) {
        onBankTransferError(resTransfers.messageCode);
      } else {
        if (onSuccess) onSuccess(resTransfers.result);

        setTransfers(resTransfers.result);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingTransfers(false);
    }
  };

  useEffect(() => {
    fetchTransfers();

    return () => {
      setLoadingTransfers(false);
      setTransfers([]);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    loadingTransfers,
    transfers,
    fetchTransfers,
  };
};

export default useBankTransfers;
